export function StatusProgressBar({
  pct,
  label,
}: {
  pct: number;
  label?: string;
}) {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div className="sm-progress">
      {label ? <span className="sm-progress-label">{label}</span> : null}
      <div
        className="sm-progress-track"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="sm-progress-fill"
          style={{ width: `${clamped}%` }}
        />
      </div>
      <strong className="sm-progress-pct">{clamped}%</strong>
    </div>
  );
}

/** Circular progress used on production dashboard and episode status. */
export function ProgressRing({
  pct,
  caption = "færdig",
}: {
  pct: number;
  caption?: string;
}) {
  const clamped = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <div
      className="sm-dash-ring"
      role="img"
      aria-label={`${clamped} procent ${caption}`}
    >
      <svg viewBox="0 0 120 120">
        <circle cx="60" cy="60" r="52" className="sm-dash-ring-bg" />
        <circle
          cx="60"
          cy="60"
          r="52"
          className="sm-dash-ring-fg"
          style={{
            strokeDasharray: `${(clamped / 100) * 327} 327`,
          }}
        />
      </svg>
      <div className="sm-dash-ring-label">
        <strong>{clamped}%</strong>
        <span>{caption}</span>
      </div>
    </div>
  );
}

/** Checklist counts shown immediately after the progress ring. */
export function StatusPointsStat({
  completed,
  total,
}: {
  completed: number;
  total: number;
}) {
  return (
    <div className="sm-dash-stat sm-dash-stat-points">
      <strong>
        {completed}/{total || 0}
      </strong>
      <span>punkter færdige</span>
    </div>
  );
}

export function ProgressCluster({
  pct,
  completed,
  total,
}: {
  pct: number;
  completed: number;
  total: number;
}) {
  return (
    <div className="sm-progress-cluster">
      <ProgressRing pct={pct} />
      <StatusPointsStat completed={completed} total={total} />
    </div>
  );
}

/** Ring + scene / duration / checklist counts — shown under Status header. */
export function EpisodeStatusStats({
  sceneCount,
  durationLabel,
  completed,
  total,
  pct,
}: {
  sceneCount: number;
  durationLabel: string;
  completed: number;
  total: number;
  pct: number;
}) {
  return (
    <div className="sm-status-hero">
      <ProgressRing pct={pct} />
      <div className="sm-dash-stats">
        <StatusPointsStat completed={completed} total={total} />
        <div className="sm-dash-stat">
          <strong>{sceneCount}</strong>
          <span>{sceneCount === 1 ? "scene" : "scener"}</span>
        </div>
        <div className="sm-dash-stat">
          <strong>{durationLabel}</strong>
          <span>samlet varighed</span>
        </div>
      </div>
    </div>
  );
}
